export const checkForwardMatch = (target, keyword) => {
	const regex = new RegExp(`^${keyword}.*`, 'g');
	return regex.test(target);
};

export const toLastUpdateString = (dateNumber) => {
	if(!dateNumber) return '-';
	const lastUpdated = new Date(dateNumber);
	return lastUpdated.toLocaleString();
};

export const tlMilliSecondsToMinute = ms =>{
	const min = Math.floor(ms / 60 / 1000);
	const minStr = ( '00' + min ).slice( -2 );
	const sec = Math.floor((ms - (min * 60 * 1000))/1000);
	const secStr = ( '00' + sec ).slice( -2 );
	return {
		min : minStr,
		sec : secStr
	};
};

export const tlSecondsToMinute = sec =>{
	return tlMilliSecondsToMinute(sec*1000);
};